import { useMediaQuery } from 'react-responsive';

export function useIsSM() {
    return useMediaQuery({ query: '(min-width: 640px)' });
}
export function useIsMD() {
    return useMediaQuery({ query: '(min-width: 768px)' });
}

export function useIsLG() {
    return useMediaQuery({ query: '(min-width: 1024px)' });
}
export function useIsXL() {
    return useMediaQuery({ query: '(min-width: 1280px)' });
}

export function useIsXXL() {
    return useMediaQuery({ query: '(min-width: 1536px)' });
}
